import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { DashboardPlanillaData } from '../types/dashboard';
import { DashboardService } from '../services/dashboardService';

interface DashboardStore {
  data: DashboardPlanillaData | null;
  loading: boolean;
  error: string | null;
  anio: number;

  setAnio: (anio: number) => void;
  loadDashboard: (anio?: number) => Promise<void>;
}

export const useDashboardStore = create<DashboardStore>()(
  devtools(
    (set, get) => ({
      data: null,
      loading: false,
      error: null,
      anio: new Date().getFullYear(),

      setAnio: (anio) => set({ anio }),

      loadDashboard: async (anio?: number) => {
        set({ loading: true, error: null });
        try {
          const year = anio ?? get().anio;
          const data = await DashboardService.getDashboard(year);
          set({ data, loading: false });
        } catch (e) {
          set({ error: e instanceof Error ? e.message : 'Error cargando dashboard', loading: false });
        }
      },
    }),
    { name: 'DashboardStore' }
  )
);
